import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import escoLogo from '../../../../assets/logo/esco-logo.svg';

const Title = styled.div`
  padding: 0 5px;
  flex: 1;
  display: flex;
  align-items: center;
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
`;

const Divider = styled.span`
  display: inline-block;
  width: 1px;
  height: 28px;
  background-color: rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
`;

const StyledH1 = styled.h1`
  font-size: 1.2rem;
  font-weight: 400;
  margin: 0;
  color: #00C752;
`;

const AppTitle = () => {
  return (
    <Title>
      <StyledLink to="/">
        <img src={escoLogo} alt="ESCO" style={{ height: 36 }} />
        <Divider />
        <StyledH1>Energy Market</StyledH1>
      </StyledLink>
    </Title>
  );
};

export default AppTitle;
